import React from 'react';
import styled, { css } from 'styled-components';
import { Col, Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { boxShadow, grey } from '../../styles/constants';
import NavigateToSectionButton from '../NavigateToSectionButton';
import backgroundImage from '../../assets/geometric-leaves.png';

const BackgroundWrapper = styled.div`
  background-color: ${(props) => (props.hasGreyBackground && grey)};
  background-image: linear-gradient(to bottom, rgba(255,255,255,0.8) 0%,rgba(255,255,255,0.9) 100%),url(${backgroundImage});
`;

const FullheightContainer = styled(Container)`
  min-height: 100vh;
  flex-direction: column;
  display: flex;
`;

const CenteringRow = styled(Row).withConfig({
  shouldForwardProp: (prop) => !['noCentering'].includes(prop),
})`
  flex-grow: 1;
  display: flex;
  align-items: ${(props) => (props.noCentering ? 'start' : 'center')};
`;

const stickyStyling = css`
  position: sticky;
  bottom: 10px;
  background-color: white;  
  border-radius: 5px;
  box-shadow: ${boxShadow};
`;

const TopOrBottomRow = styled(Row)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  ${(props) => props.$sticky && stickyStyling};
  z-index: 99;
`;

const Section = ({
  previousNav, nextNav, children, hasGreyBackground, noCentering, nextNavSticky,
}) => (
  <BackgroundWrapper
    hasGreyBackground={hasGreyBackground}
  >
    <FullheightContainer>
      {previousNav && previousNav.handleClick && (
      <TopOrBottomRow>
        <NavigateToSectionButton
          direction="up"
          handleClick={previousNav.handleClick}
          disabled={previousNav.disabled}
        />
      </TopOrBottomRow>
      )}
      <CenteringRow noCentering={noCentering}>
        <Col>
          {children}
        </Col>
      </CenteringRow>
      {nextNav && nextNav.handleClick && (
      <TopOrBottomRow $sticky={nextNavSticky}>
        <NavigateToSectionButton
          direction="down"
          handleClick={nextNav.handleClick}
          disabled={nextNav.disabled}
        />
      </TopOrBottomRow>
      )}
    </FullheightContainer>
  </BackgroundWrapper>
);

const navShape = PropTypes.shape({
  handleClick: PropTypes.func,
  disabled: PropTypes.bool,
});

const navShapeDefault = {
  disabled: false,
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  previousNav: navShape,
  nextNav: navShape,
  hasGreyBackground: PropTypes.bool,
  noCentering: PropTypes.bool,
  nextNavSticky: PropTypes.bool,
};

Section.defaultProps = {
  hasGreyBackground: false,
  noCentering: false,
  previousNav: navShapeDefault,
  nextNav: navShapeDefault,
  nextNavSticky: false,
};

export default Section;
